var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{attrs:{"placeholder":_vm.placeholder},on:{"input":_vm.inputHandler},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }